import transaction from '@js/store/modules/transaction';

export default {
    created() {
        if (this.$store.hasModule('transaction')) return;
        this.$store.registerModule('transaction', transaction);
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/receipt/store-mixin.js